import { UsersRepo as usersRepo } from '@services/users.repo';
import { UserItem as userItem } from '../UserItem';
import { ClientRepo as clientRepo } from '@services/clients/client.repo'
import * as _ from 'lodash';
import { extractErrorMessage } from "@common/utils/errorUtils";

class userInfoController implements angular.IOnInit {
  public selectedUser: userItem;
  public clientsForUser: Array<any> = [];
  public clients: Array<any> = [];

  public userRoles: Array<any>;

  public isLoading = false;
  public isLoadingRoles = false;
  public isLoadingClients = false;

  /** @ngInject */
  constructor(private usersRepo: usersRepo, private clientRepo: clientRepo,
    private $state: angular.ui.IStateService, private $stateParams: angular.ui.IStateParamsService, private notifyjs: any) { }

  $onInit() {
    var userId = +this.$stateParams['id'];

    if (isNaN(userId)) {
      this.notifyjs('No User Id was supplied');
      return;
    }

    this.isLoading = true;
    this.isLoadingClients = true;
    this.isLoadingRoles = true;
    this.usersRepo.getUser(userId)
      .then((val) => {
        this.selectedUser = new userItem(val.data);

        this.populateClients();
        this.populateUserRoles();
      })
      .catch((err) => this.notifyjs(extractErrorMessage(err)))
      .finally(() => this.isLoading = false);
  }

  private populateClients() {
    const clientsPromise = this.clientRepo.searchClients({
      displayAllClients: true
    });
    const userClientsPromise = this.clientRepo.getClientsForUser(this.selectedUser.id);

    Promise.all([clientsPromise, userClientsPromise])
      .then(([clientsResp, userClientsResp]) => {
        const clients = clientsResp.data as { results: { id: number, name: string, clientNumber: string }[] };
        const userClients = userClientsResp.data as { id: number, name: string, clientNumber: string }[];

        this.clients = clients.results.map(c => {
          const client = { name: c.name, clientNumber: c.clientNumber };

          let filteredUserClients = userClients.filter( (uc) => uc != null);

          if (filteredUserClients.find(uc => c.clientNumber == uc.clientNumber)) {
            this.clientsForUser.push(client);
          }
          return client;
        });
      })
      .then(() => {
        this.clientsForUser.sort((a, b) => {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        });
        this.isLoadingClients = false;
      })
      .catch((err) => {
        this.notifyjs(extractErrorMessage(err));
        this.isLoadingClients = false;
      });
  }

  private populateUserRoles() {
    this.isLoadingRoles = true;
    this.usersRepo.getUserRoles(this.selectedUser.email)
      .then((val) => {
        this.userRoles = val.data as string[];
        this.isLoadingRoles = false;
      })
      .catch((err) => {
        this.notifyjs(extractErrorMessage(err));
        this.isLoadingRoles = false;
      });
  }

  private addClientsForUser() {
    this.selectedUser.clients = [];
    let clientsArray = this.clientsForUser;
    for (let i in clientsArray) {
      this.selectedUser.clients.push(clientsArray[i].clientNumber);
    }
  }

  saveUser() {
    this.isLoading = true;
    this.addClientsForUser();
    this.selectedUser.roles = this.userRoles;

    this.usersRepo.saveUser(this.selectedUser)
      .catch((err) => this.notifyjs(extractErrorMessage(err)))
      .finally(() => this.isLoading = false);
  }

  saveUserRoles() {
    this.isLoadingRoles = true;
    this.selectedUser.roles = this.userRoles;
    this.usersRepo.saveUserRoles(this.selectedUser)
      .catch((err) => this.notifyjs(extractErrorMessage(err)))
      .finally(() => this.isLoadingRoles = false);
  }

  saveUserClients() {
    this.isLoadingClients = true;
    this.addClientsForUser();
    this.usersRepo.saveUserClients(this.selectedUser)
      .catch((err) => this.notifyjs(extractErrorMessage(err)))
      .finally(() => this.isLoadingClients = false);
  }

  //TODO: Implement cancel/back button
  cancelUserEdit() {
    this.selectedUser = undefined;
    this.$state.go("root.users");
  }

  changeSelectedUserStatus() {
    this.selectedUser.isActive = !this.selectedUser.isActive;
    this.saveUser();
  }

  getUserStatus() {
    const { isActive, status } = this.selectedUser;
    if (!isActive) {
      return "Disabled";
    } else {
      switch (status) {
        case 'CONFIRMED':
          return 'Active';
        case 'FORCE_CHANGE_PASSWORD':
          return 'Awaiting Confirmation';
        default:
          return 'UnKnown';
      }
    }
  }
}

export const userInfo: angular.IComponentOptions = {
  template: require('./userInfo.html'),
  controller: userInfoController,
  bindings: {
    selectedUser: "<"
  }
};



// WEBPACK FOOTER //
// ./src/app/users/userDetails/userInfo.ts